import { requireField } from './validators';

export default class TimelineEvent {
  constructor(data = {}) {
    requireField(data.category, 'timeline.category');
    requireField(data.date, 'timeline.date');

    this.id = data.id || `time-${Math.random().toString(36).slice(2, 9)}`;
    this.category = data.category;
    this.type = data.type || '';
    this.date = data.date;
    this.description = data.description || '';
    this.severity = data.severity || 'low';
    this.sourceId = data.sourceId || null;
  }

  toJSON() {
    return { ...this };
  }
}
